export function qs<T extends Element = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): T | null {
  return root.querySelector<T>(selector);
}

export function qsa<T extends Element = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): T[] {
  return Array.from(root.querySelectorAll<T>(selector));
}

export function on<K extends keyof HTMLElementEventMap>(
  target: HTMLElement | Window | Document,
  type: K,
  listener: (ev: HTMLElementEventMap[K]) => void,
  options?: AddEventListenerOptions | boolean,
): () => void;
export function on(
  target: EventTarget,
  type: string,
  listener: (ev: Event) => void,
  options?: AddEventListenerOptions | boolean,
): () => void {
  target.addEventListener(type, listener, options);
  return () => target.removeEventListener(type, listener, options);
}

let scrollLockCount = 0;
let savedOverflow = '';

export function lockBodyScroll(): void {
  if (scrollLockCount === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  scrollLockCount++;
}

export function unlockBodyScroll(): void {
  if (scrollLockCount > 0) scrollLockCount--;
  if (scrollLockCount === 0) {
    document.body.style.overflow = savedOverflow;
    savedOverflow = '';
  }
}
